import { Location } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { DptmasterService } from 'src/app/services/dptmaster.service';
import { DivisionService } from 'src/app/services/division.service';
import { RegionService } from 'src/app/services/region.service';
import { map } from 'lodash';
import { AlertService } from 'src/app/services/alert.service';
import { error } from 'console';
import { MatOptionSelectionChange } from '@angular/material/core';

@Component({
  selector: 'app-dbtproductcomponentmappingassign',
  templateUrl: './dbtproductcomponentmappingassign.component.html',
  styleUrls: ['./dbtproductcomponentmappingassign.component.scss']
})

export class DbtproductcomponentmappingassignComponent implements OnInit {
  @Input() actionId: any;
  @Input() resultdata: any;
  @Output() backComp = new EventEmitter<any>();
  form!: FormGroup;
  value: any;
  compVal: any[] = [];
  selectedValue: any[];
  id: any;
  GetByIdResponse: any;
  filtercompVal: any[];
  dbtProductlist: any[];
  filterdbtProductlist: any[];
  classificationval: any;
  Departmentval: any;
  dptlookup: any[];
  Componentval: any = [];
  productlookup: any;
  productid: any;
  result: any;
  subDBTProductComponents: any;
  departmentid: any;

  constructor
    (
      private fb: FormBuilder,
      private dptmasterservice: DptmasterService,
      private regionService: RegionService,
      private alertService: AlertService,

    ) { }

  ngOnInit(): void {
    this.id = this.resultdata.id ? this.resultdata.id : 0,
      this.productid = this.resultdata.dbtProductId ? this.resultdata.dbtProductId : '',
      this.departmentid = this.resultdata.departmentId ? this.resultdata.departmentId : '',

    this.initialValidators();
    this.getproductlookup();
    this.departmentlookup();
    if (this.actionId == 1 || this.actionId == 2) {
      this.getComponent(this.departmentid);
    }

  }


  initialValidators() {
    this.form = this.fb.group({
      'dbtProductId': [this.actionId==1 || this.actionId==2 ? this.productid:'', Validators.required],
      'Department': [this.actionId==1 || this.actionId==2 ? this.departmentid:'', Validators.required],
      'dbtComponentId': [[], Validators.required],
    })
  }

  getproductlookup() {
    this.dptmasterservice.getproductlookup().subscribe((res) => {
      this.productlookup = res
    })
  }

  ProductSelected(event: MatOptionSelectionChange){
    if (event.isUserInput) {
      this.form.controls["Department"].setValue('');
      this.form.controls["dbtComponentId"].setValue('');
    }
  }

  productcomponentmapping(productid, departmentid) {
    const data = {
      productid, departmentid
    }
    this.dptmasterservice.productcomponentmapping(data).subscribe((res) => {
      if (this.actionId == 1 || this.actionId==2) {
        this.form.patchValue({
          dbtProductId: res.dbtProductId,
          Department: res.departmentId,
          dbtComponentId: res.subDBTProductComponents.map((component: any) => component.dbtComponentId)
        });
      }
      else if (this.actionId == 0) {
        this.form.patchValue({
          dbtComponentId: res.subDBTProductComponents.map((component: any) => component.dbtComponentId)
        });
      }
    })
  }


  departmentlookup() {
    this.dptmasterservice.getAllDept().subscribe((res) => {
      this.Departmentval = res
    })
  }

  onOptionSelected(event: MatOptionSelectionChange, item: any) {
    if (event.isUserInput) {  
      this.getComponent(item);
    }
  }

  getComponent(item) {
    this.dptmasterservice.getComponentlookup(item).subscribe((res) => {
      this.Componentval = res
      this.productcomponentmapping(this.form.value.dbtProductId, this.form.value.Department)
    })
  }


  back() {
    const msg = { show: true };
    this.backComp.emit(msg);
  }

  Update() {
    if (this.form.valid) {

      let data = {
        "id": this.id,
        "dbtProductId": this.form.value.dbtProductId,
        "departmentId": this.form.value.Department,
        "dbtComponentId": this.form.value.dbtComponentId
      }

      this.dptmasterservice.updateproductcomponentmapping(data).subscribe((res) => {
        if (res.isSuccess) {
          this.alertService.success(this.actionId == 0 ? 'Product Component Mapping Saved Successfully' : this.actionId == 1 ? 'Product Component Mapping Updated Successfully' : '');
          this.back()
        }
        else {
          this.alertService.error(res.htmlFormattedFailures);
        }
      })
    }
    else {
      this.form.markAllAsTouched();
    }


  }


}